import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { authApi } from '../api/auth'
import { api } from '../api/Api'
import type { User, Company } from '../types/auth'
import { tokenManager } from '../api/utils/tokenManager'
import MessageBox from '../services/MessageBox'

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User | null>(null)
  const showCompanySelection = ref(false)
  
  const isAuthenticated = computed(() => {
    return tokenManager.getUser() != null && tokenManager.getCompany() != null
  })
  
  async function login(email: string, password: string) {

    try {
      const response = await authApi.login({ 
        email, 
        password, 
        //device_name: 'web_app' 
      })
      if(response.success == true) {
        api.setToken(response.data.token)
        api.setUser(response.data.user)
        user.value = response.data.user
        if (response.data.companies.length <= 0) 
          throw new Error("There are no active Companies");
          
        tokenManager.setCompanyList(response.data.companies)
        if (response.data.companies.length == 1) {
          await selectSingleCompany(response.data.companies[0], email, password)
          //window.location.href = '/dashboard'
        } else {
          tokenManager.savePassword(password)
          showCompanySelection.value = true
        }
        //window.location.href = '/dashboard'
        //router.push('/dashboard')
      } else {
        throw response
      }
    } catch (error) {
      throw error
    }

  }

  async function selectSingleCompany(company: Company, email: string, password: string) {
    const apiData = {
      cid: company.uid,
      email: email,
      password: password,
    };
    const response = await api.post('/company', apiData)
    if (response.success == true) {
      api.setUser(response.data.user)
      user.value = response.data.user
      tokenManager.setMenu(response.data.menu)
      tokenManager.setPermissions(response.data.permissions)
      tokenManager.setSettings(response.data.settings)
      tokenManager.setCompany(company)      
      if (response.data.welcomed && user.value?.user_type == 'Back Office') {
        window.location.href = '/dashboard'
      } else if (user.value?.user_type == 'POS User') {
        window.location.href = '/pos'
      } else if (user.value?.user_type == 'Delivery') {
        window.location.href = '/revenue/sales/delivery-trackings'
      } else if (user.value?.user_type == 'Sales Rep') {
        window.location.href = '/reps'
      } else if (user.value?.user_type == 'Kitchen Staff') {
        window.location.href = '/revenue/sales/kitchen-orders'
      }
      else if (!response.data.welcomed && user.value?.user_type == 'Back Office') {
        window.location.href = '/welcome'
      } else {
        MessageBox.show("Please contact your administrator to set up your account.")
      }
    } else {
      throw response;
      
    }
  }

  async function selectCompany(company: Company) {
    tokenManager.setCompany(company)
    showCompanySelection.value = false
    window.location.href = '/dashboard'
  }

  async function logout() {
    try {
      //await authApi.logout()
      tokenManager.removeUser()
      tokenManager.removeCompany()
      tokenManager.remove()
      window.location.href = '/'
    } catch (error) {
      // Still clear user data even if API call fails
      tokenManager.removeUser()
      tokenManager.removeCompany()
      tokenManager.remove()
      window.location.href = '/'
    }
  }

  return {
    user,
    showCompanySelection,
    isAuthenticated,
    login,
    selectCompany,
    logout
  }
})